import { render, staticRenderFns } from "./Ptspprov.vue?vue&type=template&id=23834cc0&scoped=true"
import script from "./Ptspprov.vue?vue&type=script&lang=js"
export * from "./Ptspprov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23834cc0",
  null
  
)

export default component.exports